import type { SVGProps } from 'react';

export const SvgGuideIllustContents = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={393} height={262} viewBox="0 0 393 262" fill="none" {...props}>
    <g clipPath="url(#page-top__image--point--sp_svg__a)">
      <path fill="#fff" d="M0 0h393v262H0z" />
      <path
        fill="#F6F6F6"
        d="M196.5 262C320.488 262 421 214.542 421 156S320.488 50 196.5 50-28 97.458-28 156 72.512 262 196.5 262"
      />
      <g clipPath="url(#page-top__image--point--sp_svg__b)">
        <mask
          id="page-top__image--point--sp_svg__c"
          width={211}
          height={198}
          x={98}
          y={-3}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}>
          <path fill="#fff" d="M308.26-2.82H98V194.1h210.26z" />
        </mask>
        <g mask="url(#page-top__image--point--sp_svg__c)">
          <path
            fill="#A8D6E3"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m208.692 108.153.193 25.32-21.126-11.223-.192-25.346 21.138 11.236z"
          />
          <path
            fill="#6EB8D1"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m208.693 108.153 20.164-10.826.192 25.32-20.163 10.826z"
          />
          <path
            fill="#A5D0DD"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m187.555 96.917 20.176-10.826 21.126 11.236-20.164 10.826z"
          />
          <path
            fill="#A8D6E3"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m213.822 80.371.193 25.32-21.139-11.223-.192-25.346 21.138 11.236z"
          />
          <path
            fill="#6EB8D1"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m213.824 80.37 20.163-10.826.193 25.32-20.164 10.826z"
          />
          <path
            fill="#A5D0DD"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m192.684 69.122 20.176-10.826 21.126 11.236-20.164 10.826z"
          />
          <path
            fill="#A8D6E3"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m208.693 52.575.205 25.32-21.138-11.21-.205-25.346z"
          />
          <path
            fill="#6EB8D1"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m208.693 52.575 20.151-10.84.205 25.32-20.15 10.84z"
          />
          <path
            fill="#A5D0DD"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M187.555 41.34 207.718 30.5l21.126 11.236-20.151 10.839z"
          />
          <path
            fill="#A8D6E3"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m235.089 116.337.193 25.32-21.139-11.223-.192-25.346 21.138 11.236z"
          />
          <path
            fill="#6EB8D1"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m235.091 116.338 20.163-10.826.193 25.32-20.164 10.826z"
          />
          <path
            fill="#A5D0DD"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m213.951 105.101 20.176-10.826 21.126 11.237-20.164 10.825z"
          />
          <path
            fill="#A8D6E3"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m255.637 127.791.192 25.32-21.138-11.223-.192-25.346 21.138 11.236z"
          />
          <path
            fill="#6EB8D1"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m255.638 127.79 20.164-10.826.192 25.32-20.163 10.826z"
          />
          <path
            fill="#A5D0DD"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m234.499 116.555 20.176-10.826 21.126 11.237-20.164 10.826z"
          />
          <path
            fill="#A8D6E3"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m281.305 136.679.193 25.32-21.139-11.223-.192-25.346 21.138 11.236z"
          />
          <path
            fill="#6EB8D1"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m281.305 136.679 20.164-10.825.192 25.32-20.163 10.825z"
          />
          <path
            fill="#A5D0DD"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m260.167 125.443 20.176-10.826 21.126 11.236-20.164 10.826z"
          />
          <path
            fill="#A8D6E3"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m229.959 89.837.192 25.32-21.138-11.223-.192-25.346 21.138 11.236z"
          />
          <path
            fill="#6EB8D1"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m229.959 89.836 20.164-10.826.192 25.32-20.163 10.826z"
          />
          <path
            fill="#A5D0DD"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m208.821 78.588 20.176-10.826 21.126 11.236-20.164 10.826z"
          />
          <path
            fill="#A8D6E3"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m233.807 62.041.205 25.32-21.139-11.223-.205-25.346 21.139 11.236z"
          />
          <path
            fill="#6EB8D1"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M233.808 62.04 253.959 51.2l.205 25.32-20.151 10.839z"
          />
          <path
            fill="#A5D0DD"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m212.668 50.804 20.164-10.838 21.125 11.236-20.15 10.839z"
          />
          <path
            fill="#A8D6E3"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m213.823 26.075.193 25.32-21.126-11.223-.192-25.346 21.138 11.236z"
          />
          <path
            fill="#6EB8D1"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m213.824 26.074 20.164-10.826.192 25.32-20.164 10.826z"
          />
          <path
            fill="#A5D0DD"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M192.684 14.826 212.861 4l21.125 11.236-20.163 10.826z"
          />
          <path
            fill="#A8D6E3"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m209.139 144.075.192 25.32-21.126-11.223-.192-25.346 21.138 11.236z"
          />
          <path
            fill="#6EB8D1"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m209.14 144.074 20.163-10.825.193 25.32-20.164 10.825z"
          />
          <path
            fill="#A5D0DD"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M188 132.826 208.176 122l21.126 11.236-20.164 10.826z"
          />
          <path
            fill="#ECC737"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m242.799 38.286.193 25.346-21.139-11.236-.192-25.32 21.138 11.223z"
          />
          <path
            fill="#E48C2B"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m242.799 38.285 20.164-10.825.192 25.32-20.163 10.838-.193-25.346z"
          />
          <path
            fill="#ECC737"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m221.661 27.063 20.176-10.838 21.126 11.236-20.164 10.826z"
          />
          <path
            fill="#A8D6E3"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m257.497 97.482.218 25.32-21.138-11.223-.192-25.346 21.125 11.236z"
          />
          <path
            fill="#6EB8D1"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m257.498 97.482 20.176-10.826.193 25.32-20.164 10.826-.218-25.32z"
          />
          <path
            fill="#A5D0DD"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m236.372 86.233 20.177-10.826 21.126 11.237-20.177 10.825z"
          />
          <path
            fill="#ECC737"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m284.05 111.155.192 25.346-21.138-11.237-.193-25.32 21.139 11.224z"
          />
          <path
            fill="#E48C2B"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m284.05 111.154 20.164-10.825.192 25.345-20.164 10.826z"
          />
          <path
            fill="#ECC737"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M262.923 99.93 283.1 89.106l21.126 11.223-20.164 10.826zM223.139 166.049l.192 25.346-21.138-11.236-.193-25.32 21.139 11.223z"
          />
          <path
            fill="#E48C2B"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m223.139 166.049 20.164-10.826.192 25.346-20.164 10.826z"
          />
          <path
            fill="#ECC737"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M202.012 154.825 222.189 144l21.126 11.223-20.164 10.826z"
          />
          <path
            fill="#E3C13D"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m261.73 68.634.193 25.346-21.139-11.237-.192-25.32 21.138 11.224z"
          />
          <path
            fill="#DC882E"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m261.732 68.633 20.163-10.825.193 25.32-20.164 10.838-.192-25.345z"
          />
          <path
            fill="#E3C13D"
            stroke="#FF0019"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m240.592 57.41 20.176-10.838 21.126 11.237-20.164 10.825z"
          />
          <path
            fill="#FF0019"
            d="M151.728 142.868c2.771-1.604 7.247-1.604 9.992 0 2.758 1.603 2.732 4.194-.038 5.784l-6.811 3.925c-2.771 1.604-7.248 1.604-9.992 0-2.758-1.603-2.733-4.194.038-5.784zM165.387 150.349c2.77-1.604 7.247-1.604 9.992 0 2.745 1.603 2.732 4.194-.039 5.784l-6.811 3.925c-2.77 1.604-7.247 1.604-9.992 0-2.745-1.603-2.732-4.194.039-5.785z"
          />
          <path
            fill="#F9DDD6"
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M176.638 101.905c-10.582 3.835-6.106-.154-16.79-3.695l-8.004 6.658c1.719 21.587 2.437 39.493 2.437 39.493 2.296 2.014 4.887 2.014 7.273.026l.91-33.773h3.015l1.872 40.93c2.707 2.116 6.157 1.398 7.697-.423 0 0 2.616-30.938 1.577-49.216z"
          />
          <path
            fill="#FF0019"
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m179.113 97.602.756 26.205s-4.976 6.182-17.906.859c-6.554-2.693-12.493-5.028-15.225-10.915l.834-18.638 3.822 3.669c10.915 3.604 27.719-1.18 27.719-1.18"
          />
          <path
            fill="#FAEBAE"
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m138.285 68.897 8.21-3.771 10.761 12.173c1.591 7.478-9.928 10.761-12.814 4.887-2.27-4.002-6.157-13.289-6.157-13.289"
          />
          <path
            fill="#FAEBAE"
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M148.045 60.845c.834-3.001 4.4-4.849 6.414-6.683 2.001-1.821 8.581-3.732 8.581-3.732l14.019 3.732c4.695 2.938 9.248 9.48 8.415 14.956-.475 3.169-5.606 21.742-5.606 21.742s.18 11.428-.461 10.979c-9.582 4.669-26.154 4.515-32.26-7.709l1.103-14.866s-2.86-8.85-.205-18.432z"
          />
          <path
            fill="#F9DDD6"
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M147.417 68.065a5.496 5.496 0 0 0 5.49 5.49 5.496 5.496 0 0 0 5.49-5.49 5.496 5.496 0 0 0-5.49-5.49 5.496 5.496 0 0 0-5.49 5.49"
          />
          <path
            fill="#FAEBAE"
            d="M174.277 77.635c-4.053-1.898-16.431-8.594-16.431-8.594-2.835-.218-5.259 4.733-5.144 8.273a584 584 0 0 1 8.723 6.042c4.117 3.232 8.478 8.158 14.225 6.067 2.334-.847 6.349-5.13 7.298-7.44"
          />
          <path
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M173.481 77.07c-4.348-1.064-14.238-8.08-14.238-8.08-2.963 1.064-4.335 2.308-5.31 5.835 2.809 3.387 5.862 6.773 8.619 9.351 4.4 3.681 9.569 6.67 14.79 3.502 2.129-1.296 5.22-6.285 5.695-8.722"
          />
          <path
            fill="#F9DDD6"
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M164.926 57.52c7.234 2.066 14.776-2.129 16.841-9.363s-2.129-14.776-9.363-16.841-14.777 2.129-16.842 9.363 2.13 14.776 9.364 16.841"
          />
          <path
            fill="#FF0019"
            d="M169.197 45.053a2.107 2.107 0 0 1-2.616 1.45 2.11 2.11 0 0 1-1.45-2.617 2.11 2.11 0 0 1 2.617-1.45 2.11 2.11 0 0 1 1.449 2.617M175.048 47.193a2.12 2.12 0 0 0 2.616-1.45 2.12 2.12 0 0 0-1.449-2.616 2.125 2.125 0 0 0-2.617 1.45 2.12 2.12 0 0 0 1.45 2.616M143.159 49.605c3.386-1.731-.282-10.774 2.424-13.442 3.104-3.066 8.53-3.335 11.968-.667.23.18.307.475.218.744l-2.566 9.928c-2.552 6.837-8.44 11.826-15.61 8.76-1.552-.654-2.437-1.077-3.386-2.462-.654-.95-1.296-2.386-1.373-3.669-.038-.615.719-.936 1.142-.5 1.808 1.86 4.874 2.489 7.196 1.296z"
          />
          <path
            fill="#FF0019"
            d="M173.673 30.185c4.425 1.63 6.452 4.63 7.593 6.118-4.771 5.708-17.534 2.938-23.19.026-.167-.295-1.103-.628-1.347-.975 3.001-4.835 9.646-7.978 16.931-5.156z"
          />
          <path
            fill="#FF0019"
            stroke="#FF0019"
            strokeMiterlimit={10}
            strokeWidth={2.565}
            d="M150.919 55.544c.218.128.398.462.398.718l-.052 20.305c0 .27-.179.372-.397.244l-8.299-5.054c-.218-.129-.398-.462-.398-.719l.052-20.304c0-.27.179-.372.397-.244z"
          />
          <path
            fill="#F9DDD6"
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M135.039 64.257a5.495 5.495 0 0 0 5.489 5.49 5.496 5.496 0 0 0 5.49-5.49 5.496 5.496 0 0 0-5.49-5.49 5.495 5.495 0 0 0-5.489 5.49"
          />
          <path
            fill="#FF0019"
            stroke="#FF0019"
            strokeWidth={2.565}
            d="M142.875 166.858c0 .347-.219.885-1.116 1.411s-2.142.808-3.438.808c-1.295 0-2.54-.295-3.45-.808l-5.375-3.104c-.911-.526-1.141-1.077-1.141-1.424 0-.346.218-.885 1.116-1.41.897-.526 2.142-.809 3.437-.809 1.296 0 2.54.295 3.451.809l5.374 3.104c.911.526 1.142 1.077 1.142 1.423ZM132.102 172.755c0 .347-.218.885-1.116 1.411s-2.142.808-3.437.808c-1.296 0-2.54-.295-3.451-.808l-5.374-3.104c-.911-.526-1.142-1.077-1.142-1.424 0-.346.218-.885 1.116-1.41.898-.526 2.142-.809 3.438-.809 1.295 0 2.539.295 3.45.809l5.375 3.104c.91.525 1.141 1.077 1.141 1.423Z"
          />
          <path
            fill="#F9DDD6"
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M117.185 129.773c8.298 3.002 4.784-.128 13.173-2.898l6.272 5.22c-1.347 16.932-1.911 30.964-1.911 30.964-1.796 1.578-3.823 1.578-5.708.013l-.706-26.475h-2.36l-1.462 32.093c-2.129 1.655-4.823 1.09-6.041-.333 0 0-2.053-24.256-1.245-38.584z"
          />
          <path
            fill="#ABDCE9"
            d="m140.453 111.985.487 36.005c-6.721 3.296-23.255 3.219-31.053-.808-.539.346 6.336-24.627 6.336-24.627s-2.732 2.039-2.873-1.296c-.257-6.016.231-15.033 4.925-18.419l13.686-7.901"
          />
          <path
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m140.453 111.985 1.667 36.005c-6.76 4.746-24.422 3.219-32.233-.808-.539.346 6.336-24.627 6.336-24.627s-2.732 2.039-2.873-1.296c-.257-6.016.231-15.033 4.925-18.419l13.686-7.901"
          />
          <path fill="#ABDCE9" d="m119.774 122.461-7.221 12.545-6.26-3.527 7.979-21.844.654-2.181" />
          <path
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m119.774 122.461-7.221 12.545-6.26-3.527 7.979-21.844.654-2.181"
          />
          <path fill="#ABDCE9" d="m133.884 100.916 26.398 1.039v7.837l-18.971-.359-.847 2.116" />
          <path
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="m133.884 99.758 26.218 1.744-.18 8.274-19.458-.385v2.142"
          />
          <path
            fill="#FF0019"
            d="M137.886 79.968c4.271 2.181 5.887 10.185 5.887 10.185s-6.31 17.29-16.61 15.315c-10.3-1.988-17.547-8.71-17.547-8.71 2.899-1.923 6.747-8.196 7.709-12.172 1.231-5.092 7.58-6.477 9.709-6.683 2.194-.218 4.272.796 4.272.796s2.296-.911 6.567 1.27z"
          />
          <path
            fill="#F9DDD6"
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M118.8 90.053c1.449-6.58 7.952-10.736 14.532-9.287 6.581 1.45 10.736 7.953 9.287 14.533s-7.953 10.736-14.533 9.287c-6.58-1.45-10.736-7.953-9.286-14.533"
          />
          <path
            fill="#FF0019"
            d="M129.78 90.976a1.894 1.894 0 0 0-2.258 1.437c-.231 1.013.424 2.026 1.437 2.257s2.026-.423 2.257-1.436c.231-1.014-.423-2.027-1.436-2.258M137.385 91.116a1.893 1.893 0 0 0-2.257 1.437c-.231 1.013.423 2.026 1.436 2.257 1.014.231 2.027-.423 2.258-1.436.231-1.014-.423-2.027-1.437-2.258M130.074 80.313c-6.99.334-11.287 5.31-11.993 10.352.321.205 1.206.128 1.45.32 5.682.334 17.136-2 18.971-8.401-1.476-.808-4.22-2.527-8.428-2.258z"
          />
          <path
            fill="#FF0019"
            d="M132.256 83.338c0 .218.308.641.295.82 1.603 2.938 6.349 7.89 10.107 6.812-.051-.988-.064-2.886-1.5-4.9-2.348-3.374-6.17-3.95-8.889-2.732z"
          />
          <path
            fill="#F9DDD6"
            stroke="#FF0019"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.565}
            d="M113.746 135.265a5.496 5.496 0 0 1-5.49 5.49 5.496 5.496 0 0 1-5.49-5.49 5.496 5.496 0 0 1 5.49-5.49 5.496 5.496 0 0 1 5.49 5.49M162.913 110.627c.385-.039.718-.077.962-.129.423-.089.988-.128 1.629-.59.205-.153.256-.179.333-.256.167-.141.449-.385.68-.911.334-.757.411-1.949 1.411-2.116.59-.103 1.899-.834 2.553-1.232 1.193-.718.975-2.411-.308-3.052-1.77-.873-6.414-2.86-8.697-2.053-2.668.95-4.386 2.591-4.181 5.388.218 2.924 2.693 5.246 5.618 4.951"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="page-top__image--point--sp_svg__a">
        <path fill="#fff" d="M0 0h393v262H0z" />
      </clipPath>
      <clipPath id="page-top__image--point--sp_svg__b">
        <path fill="#fff" d="M98-2.82h210.26V194.1H98z" />
      </clipPath>
    </defs>
  </svg>
);
